import { mostrarAvisoVitalCasa } from "./mostrarAvisoVitalCasa";
import { uploadCaptacionDocumento } from "../services/captacionUpload";

const ROLES_FORZAR = ["admin", "administrador", "director", "secretaria"];

export function usuarioPuedeForzarValidacionEncargoUi(usuario) {
  return ROLES_FORZAR.includes(String(usuario?.rol || "").toLowerCase());
}

/**
 * Aviso cuando la revisión automática no acepta el encargo.
 * La secretaría / admin / director puede autorizar (forzar validación).
 */
export function mostrarAvisoEncargoNoValidado({
  mensaje,
  rev = null,
  usuario = null,
  captacionId = null,
  file = null,
  meta = null,
  onTrasForzarOk = null,
  onTrasAviso = null,
} = {}) {
  let texto = String(mensaje || rev?.mensaje || "").trim()
    || "Este archivo no es un Encargo de venta ni una Exclusiva de Vitalcasa. No se ha registrado como encargo.";
  if (rev?.conservadoComoGenerico && !/documento genérico/i.test(texto)) {
    texto = `${texto}\n\nEl archivo se ha guardado como documento genérico.`;
  }

  const puedeForzar = !!(
    rev?.puedeForzarValidacion
    || usuarioPuedeForzarValidacionEncargoUi(usuario)
  );

  const acciones = [{ label: "Entendido", primary: true }];
  if (puedeForzar && captacionId && file) {
    acciones.unshift({
      label: "Autorizar como encargo",
      variante: "validar",
      primary: false,
      onClick: async () => {
        try {
          const doc = await uploadCaptacionDocumento(captacionId, file, {
            ...(meta || {}),
            tipo_codigo: meta?.tipo_codigo || "nota_encargo",
            nombre_documento: meta?.nombre_documento || file.name || "Encargo firmado",
            forzar_validacion_encargo: true,
          });
          const revOk = doc?.encargoRevision;
          if (revOk && revOk.ok === false) {
            mostrarAvisoVitalCasa(revOk.mensaje || "No se pudo autorizar el encargo", {
              titulo: "No se ha validado el encargo",
              boton: "Entendido",
              cerrarSoloConBoton: true,
            });
            return;
          }
          if (!doc?.id && !doc?.url) {
            mostrarAvisoVitalCasa("No se recibió el archivo. Prueba de nuevo.", {
              titulo: "No se ha validado el encargo",
              boton: "Entendido",
              cerrarSoloConBoton: true,
            });
            return;
          }
          if (typeof onTrasForzarOk === "function") {
            await onTrasForzarOk(doc);
          } else {
            mostrarAvisoVitalCasa(
              "Documento autorizado como encargo. Si la ficha está completa, pasará a Para Revisar.",
              {
                titulo: "Encargo validado manualmente",
                boton: "Entendido",
                variante: "aviso",
                cerrarSoloConBoton: true,
              },
            );
          }
        } catch (errF) {
          mostrarAvisoVitalCasa(
            errF.encargoRevision?.mensaje
              || errF.response?.data?.encargoRevision?.mensaje
              || errF.response?.data?.error
              || errF.message
              || "Error al autorizar el encargo",
            {
              titulo: "No se ha validado el encargo",
              boton: "Entendido",
              cerrarSoloConBoton: true,
            },
          );
        }
      },
    });
  }

  mostrarAvisoVitalCasa(texto, {
    titulo: "Encargo no validado",
    cerrarSoloConBoton: true,
    acciones,
  });
  if (typeof onTrasAviso === "function") onTrasAviso();
}
